import React from 'react';
import UserModule from '../Users/UserModule';
import { useAuth } from '../../AuthContext';
import UserProfileModule from '../Users/UserProfileModule';
import CircularProgress from '@mui/material/CircularProgress';

function Students({ orgId }) {
  const { userRole, user, studentInfo, loading } = useAuth();

  // If the user is a student, show their own profile directly
  if (userRole === 'STUDENT') {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <CircularProgress />
        </div>
      );
    }
    if (!user) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          Failed to load profile
        </div>
      );
    }
    return (
      <div style={{ padding: '10px' }}>
        <UserProfileModule
          key={user.userId || 'student-profile'}
          selectedUser={{ user, studentInfo }} // Automatically normalized by UserProfileModule
          userType="STUDENT"
          orgId={orgId}
        />
      </div>
    );
  }

  return <UserModule userType="STUDENT" orgId={orgId} />;
}

export default Students;